import { createFileRoute } from '@tanstack/react-router'
import { ArticleShow } from '@/features/articles/pages/article-show'

export const Route = createFileRoute('/_authenticated/articles/$articleId/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { articleId } = Route.useParams()
  
  return <ArticleShow articleId={articleId} />
}
